<div class="backButton {{ addClass }}" (click)="goBack()">
	<i class="backButton__icon tagmeicon tagmeicon-voltar"></i>
	<span class="backButton__title">Voltar</span>
</div>
